<template>
  <form @submit.prevent="changePassword">
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-lock font-11"></i>
        <span>Old password</span>
        <em>(required)</em>
        <input type="password" placeholder="Gammel passord" v-model="oldPassword"/>
    </div>
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-lock font-11"></i>
        <span>New password</span>
        <em>(required)</em>
        <input type="password" placeholder="Ny passord" v-model="newPassword"/>
    </div>
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-lock font-11"></i>
        <span>Confirm new password</span>
        <em>(required)</em>
        <input type="password" placeholder="Bekreft ny passord" v-model="newPasswordConf"/>
    </div>
    <p class="feedback" v-if="feedback">{{ feedback }}</p>
    <div class="clear"></div>
    <div class="center-allign">
        <ui-button color="red" :loading="loading" >Endre passord</ui-button>
    </div>
  </form>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/functions'

export default {
    name: 'ChangePawword',
    data(){
        return{
            feedback: null,
            oldPassword: null,
            newPassword: null,
            newPasswordConf: null,
            loading: false
        }
    },
    methods:{
        changePassword(){
            this.loading = true
            if(this.newPassword != this.newPasswordConf){
                this.feedback = 'confirmation password must match'
            } else if(this.analyzePassword(this.newPassword) == 'weak'){
                this.feedback = 'password is too weak'
            } else {
                this.feedback = null
                console.log(this.newPassword)
                const user = firebase.auth().currentUser
                const credential = firebase.auth.EmailAuthProvider.credential(
                    user.email, 
                    this.oldPassword
                );
                user.reauthenticateWithCredential(credential)
                .then(() => {
                    return user.updatePassword(this.newPassword)
                }).then(() => {
                    this.loading = false
                    this.oldPassword = null
                    this.newPassword = null
                    this.newPasswordConf = null
                    this.feedback = 'Password changed successfully'
                }).catch(err => {
                    this.feedback = err.message
                    this.loading = false
                })
                
            }
        },
        analyzePassword(value){
            const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})")
            const mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})")

            if(strongRegex.test(value)) {
                return 'strong'
            } else if(mediumRegex.test(value)) {
                return 'medium'
            } else {
                return 'weak'
            }
        }
    } 
}
</script>

<style>

</style>